<div class="backdrop-aguardando-download"></div>

<div class="modal-aguardando-download">
  <div class="conteudo">
    <span class="icone-wrapper">
      <mat-icon class="icone-download" aria-hidden="true">file_download</mat-icon>
    </span>
    <p>{{ mensagem }}</p>
  </div>
</div>
